<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{contact?.DisplayName}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body">
  <form *ngIf="contact">
    <mes-api-response-summary class="d-none" [response]="response"></mes-api-response-summary>
    <ng-container *transloco="let t; read: 'ime.common.contacts'">
      <div class="form-group row">
        <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="code" name="code" [(ngModel)]="contact.Code">
        </div>
      </div>
      <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label">{{t('Name')}}</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="name" name="name" [(ngModel)]="contact.Name">
        </div>
      </div>
      <div class="form-group row">
        <label for="Comment" class="col-sm-4 col-form-label">{{t('Comment')}}</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="Comment" id="Comment" [(ngModel)]="contact.Comment"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="card-title d-flex pb-1">
                <h5 class="d-inline-block">{{t('Specs')}}</h5>
                <div class="ms-auto">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent.addNewSpecLine()">
                    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                    {{t('Add')}}
                  </button>
                </div>
              </div>
              <ime-spec-lines-edit [context]="contact" [wasValidated$]="wasValidated$"/>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
<mes-web-edit-modal-buttons [entityId]="entityId"
                            [hasDeleteButton]="!!entityId"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (addClick)="add()"
                            (cancelClick)="bsModalRef.dismiss()"/>
